import { render } from "./AccountChargeBox.vue?vue&type=template&id=390ffcda&scoped=true&ts=true"
import script from "./AccountChargeBox.vue?vue&type=script&lang=ts"
export * from "./AccountChargeBox.vue?vue&type=script&lang=ts"

import "./AccountChargeBox.vue?vue&type=style&index=0&id=390ffcda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390ffcda"]])

export default __exports__